export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const EMAIL_FIELD_NAMES = [
  "email",
  "hisEmail",
  "herEmail",
  "eMail",
  "contact_email",
  "emailSearch",
] as const;

export function trimEmail(value: string | null | undefined): string {
  return typeof value === "string" ? value.trim() : "";
}

export function isEmailFieldName(name: string): boolean {
  return (EMAIL_FIELD_NAMES as readonly string[]).indexOf(name) !== -1;
}

export function trimIfEmailField(name: string, value: unknown): unknown {
  if (typeof value === "string" && isEmailFieldName(name)) {
    return value.trim();
  }
  return value;
}

export function emailFormatError(
  value: string,
  message = "Invalid email format",
): string {
  const trimmed = trimEmail(value);
  return trimmed && !EMAIL_REGEX.test(trimmed) ? message : "";
}
